<template>
  <div class="organ">
    <div class="orgTopbg">
      <!-- <img class="orgbg" src="../../assets/images/pageHome/topTitle.png" alt /> -->
      <div class="orgTop">居民需求</div>
    </div>
    <div class="orgCenter">
      <div class="orgLeft">
        <div class="orgTab">
          <img class="orgImgs" src="../../assets/images/orgTab.png" alt />
          <div class="orgBox">
            <div
              :class="[item.flage ? 'active' : 'orgList']"
              v-for="(item, index) in orgList"
              :key="index"
              @click="changeName(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="orgRight">
        <img
          src="../../assets/images/pageHome/personNeedList_centerBg.png"
          alt=""
          srcset=""
          class="personNeedListBg"
        />
        <div class="orgTitle">
          <div class="orgSearch">
            <img
              class="typeImg"
              style="height: auto; padding-top: 20px"
              src="../../assets/images/hType.png"
              alt
            />
            <div class="typeText">服务类别</div>
            <select v-model="type" name="fruit" class="serveClass">
              <option value>请选择</option>
              <option value="www.baidu.com">百度</option>
              <option value="www.sogou.com">搜狗</option>
              <option value="www.google.com">谷歌</option>
            </select>
            <select v-model="type" name="fruit" class="secondLevel">
              <option value>请选择</option>
              <option value="www.baidu.com">百度</option>
              <option value="www.sogou.com">搜狗</option>
              <option value="www.google.com">谷歌</option>
            </select>
            <div class="set">清空</div>
            <div class="orgSearchs">搜索</div>
          </div>
        </div>
        <div class="orgRightop" style="padding: 0 21px">
          <div class="orgConter" v-for="(item, index) in 4" :key="index + item">
            <div class="orgConLeft">杭州市江干区丁兰街道行政服务中心</div>
            <div class="orgConRight">
              <img
                class="orgAddress"
                src="../../assets/images/orgAddress.png"
                alt=""
              />
              <div class="orgNewtxt" style="padding-bootom: 3px">
                杭州市上城区丁兰街道
              </div>
            </div>
          </div>
        </div>
        <Pagination :total="total" @pagination="fetchData" />
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/pagination";
export default {
  name: "",
  components: {
    Pagination,
  },

  data() {
    return {
      currentPage: 0,
      total: 10,
      searchForm: {
        pageSize: 1,
      },
      type: "",
      input: "",
      value: "",
      orgList: [
        { name: "湖滨街道", flage: false },
        { name: "清波街道", flage: false },
        { name: "小营街道", flage: false },
        { name: "望江街道", flage: false },
        { name: "南星街道", flage: false },
        { name: "紫阳街道", flage: false },
        { name: "闸弄口街道", flage: false },
        { name: "凯旋街道", flage: false },
        { name: "采荷街道", flage: false },
        { name: "四季青街道", flage: false },
        { name: "笕桥街道", flage: false },
        { name: "彭埠街道", flage: false },
        { name: "九堡街道", flage: false },
        { name: "丁兰街道", flage: false },
      ],
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
    };
  },
  created() {
    console.log("jinlai");
    this.orgList.map((v) => {
      v.flage = false;
    });
  },
  methods: {
    fetchData(e) {
      console.log(e);
    },
    handleCurrentChange(cpage) {
      this.currentPage = cpage || 9;
    },
    jumpFirstPage() {
      this.$refs.pagination.handleCurrentChange(1);
      this.$emit("handleCurrentChange", 1);
    },
    jumpLastPage() {
      let font = this.$refs.pagination;
      let cpage = Math.ceil(font.total / font.pageSize);
      font.handleCurrentChange(cpage);
    },
    changeName(item) {
      console.log(item, "item");
      this.orgList.map((v) => {
        v.flage = false;
        if (item.name == v.name) {
          v.flage = true;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
select {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: url("../../assets/images/orgup.png") no-repeat scroll right center /
    15% 21%;
  // /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  padding: 0 10px;
  margin: 0 10px;
  // width: 118px;
  height: 40px;
  background-color: #713608;
  opacity: 0.8;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.9;
  padding-right: 14px;
}
select::-ms-expand {
  display: none;
}
input {
  background: none;
  outline: none;
  border: 0px;
}
input::-webkit-input-placeholder {
  line-height: 24px;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.3;
}
.organ {
  height: 1080px;
  //   background: url("../../assets/images/bg.jpg") no-repeat center/100% 100%;
  background: #333;
}
.orgTab {
  width: 100%;
  height: 100%;
  img {
    padding: 0;
    margin: 0;
  }
  .orgImgs {
    width: 100%;
    height: 90px;
  }
  .orgBox {
    padding-bottom: 1px;
    height: 100%;
    margin-top: -5px;
    background: url("../../assets/images/orgTaber.png") no-repeat center/100%
      100%;
  }
  .orgList:first-child {
    margin-top: 0;
    padding-top: 16px;
  }
  .active:first-child {
    margin-top: 0;
    padding-top: 16px;
  }
  .orgList {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    height: 24px;
    margin: 35px 0;
    text-align: center;
    opacity: 0.6;
  }
  .active {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    height: 24px;
    margin: 35px 0;
    text-align: center;
    opacity: 1;
  }
}
.orgConter {
  padding: 0 30px;
  background: url("../../assets/images/listbg.png") no-repeat center/100% 100%;
  height: 99px;
  widows: 98%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 11px;
  .orgConLeft {
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 99px;
  }
  .orgConRight {
    display: flex;
    flex-direction: row;
    font-size: 28px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.4;
    line-height: 99px;
    .orgAddress {
      width: 23px;
      height: 30px;
      margin-right: 10px;
      margin-top: 35px;
    }
  }
}
.orgTopbg {
  height: 89px;
  background: url(../../assets/images/pageHome/topTitle.png) no-repeat
    center/100% 100%;
  .orgbg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
  }

  .orgTop {
    transform: translateY(-5px);
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    opacity: 0.91;
    height: 80px;
    line-height: 80px;
    background: linear-gradient(184deg, #ffe01a 0%, #be8840 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-image: url("../../assets/images/pageHome/topTitle.png") no-repeat
      center/100% 100%;
    text-align: center;
  }
}
.orgInput {
  width: 1000px;
  height: 50px;
  background: #502707;
  opacity: 0.8;
  border-radius: 5px;
  display: flex;
  align-content: center;
  // margin-top: 5px;
  margin-left: 5px;
  .searchs {
    width: 24px;
    height: 24px;
    margin: 14px;
  }
  .orgText {
    line-height: 24px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.9;
    margin: 13px 0;
  }
  .block {
    margin: 0 20px;
    margin-top: 8px;
    height: 34px;
    border: 2px solid #eacb1c;
  }
  .oInput {
    height: 24px;
    margin-top: 13px;
    font-size: 22px;
    color: #ffffff;
  }
}
.set {
  width: 76px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.8;
  background: url("../../assets/images/set.png") no-repeat center/100% 100%;
}
.orgSearchs {
  width: 76px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.8;
  background: url("../../assets/images/orgSearch.png") no-repeat center/100%
    100%;
}
.orgSearch {
  display: flex;
  align-items: center;
  height: 57%;
  .typeImg {
    width: 20px;
    height: 27px;
    padding-top: 5px;
    margin: 0 9px 0 20px;
  }
  .typeText {
    line-height: 24px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    opacity: 0.9;
  }
  .serveClass {
    width: 200px;
    padding: 5px;
  }
  .secondLevel {
    padding: 5px;
    width: 120px;
  }
}
.orgCenter {
  display: flex;
  flex-direction: row;
}
.orgItext {
  display: flex;
  flex-direction: row;
  .oText {
    width: 24%;
  }
}
.orgLeft {
  margin-left: 30px;
  margin-top: 10px;
  width: 10%;
  height: 75.6%;
  /deep/.el-aside {
    background-color: transparent !important;
  }
}
/deep/.el-menu {
  background-color: transparent !important;
}
.el-menu {
  width: 200px;
  height: 909px;
  background: url("../../assets/images/orgLeft.png") no-repeat center/100% 100%;

  .el-submenu {
    /deep/ .el-submenu__title {
      width: 198px;
      height: 90px;
      background: url("../../assets/images/orgLeft1.png") no-repeat center/100%
        100%;
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      padding: 0;
      text-align: center;
      line-height: 90px;
      opacity: 0.5;
    }
    /deep/ .el-submenu__title:hover {
      opacity: 1;
    }
    /deep/ .el-menu-item-group__title:hover {
      background: url("../../assets/images/orgLeft2.png") no-repeat center/100%;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      height: 57px;
      line-height: 57px;
      text-align: center;
    }
    /deep/.el-menu-item-group__title {
      height: 57px;
      line-height: 57px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.6;
      padding-left: 0 !important;
      text-align: center;
    }
    /deep/.el-menu-item-group__title:hover {
      opacity: 1;
    }
  }
}
.orgRight {
  // background: url("../../assets/images/pageHome/personNeedList_centerBg.png") no-repeat center/100% 100%;
  width: 1630px;
  height: 909px;
  position: relative;
  margin-left: 20px;
  .personNeedListBg {
    display: inline-block;
    width: 1774.1px;
    height: 1007px;
    position: absolute;
    top:-20px;
    right:-40px;
  }
  .orgTitle {
    display: flex;
    align-items: center;
    background: #f5710b;
    width: 100%;
    height: 65px;
    margin-bottom: 40px;
    border-radius: 10px;
  }
}
</style>
